import React from 'react';
import { Plus } from 'lucide-react';
import { Button, AssistantCard, Pagination } from '../../ui';
import type { Assistant } from '../../../types';
import styles from './AssistantsList.module.css';

export interface AssistantsListProps {
  assistants: Assistant[];
  totalCount: number;
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
  onItemsPerPageChange: (items: number) => void;
  onAssistantClick: (assistant: Assistant) => void;
  onCreateAssistant: () => void;
  onCreateRemoteAssistant: () => void;
  isLoading?: boolean;
}

export const AssistantsList: React.FC<AssistantsListProps> = ({
  assistants,
  totalCount,
  currentPage,
  totalPages,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange,
  onAssistantClick,
  onCreateAssistant,
  onCreateRemoteAssistant,
  isLoading = false,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.count}>{totalCount} ASSISTANTS</h2>
        <div className={styles.actions}>
          <Button
            variant="outline"
            size="sm"
            leftIcon={<Plus size={16} />}
            onClick={onCreateAssistant}
          >
            Create Assistant
          </Button>
          <Button
            variant="outline"
            size="sm"
            leftIcon={<Plus size={16} />}
            onClick={onCreateRemoteAssistant}
          >
            Create Remote Assistant
          </Button>
        </div>
      </div>

      {isLoading ? (
        <div className={styles.loading}>Loading assistants...</div>
      ) : (
        <>
          <div className={styles.grid}>
            {assistants.map((assistant) => (
              <AssistantCard
                key={assistant.id}
                id={assistant.id}
                name={assistant.name}
                author={assistant.author}
                description={assistant.description}
                avatar={assistant.avatar}
                likes={assistant.likes}
                comments={assistant.comments || 0}
                totalUses={assistant.totalUses || 0}
                isShared={assistant.isShared}
                onClick={() => onAssistantClick(assistant)}
              />
            ))}
          </div>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
            onItemsPerPageChange={onItemsPerPageChange}
          />
        </>
      )}
    </div>
  );
};

export default AssistantsList;
